import { Component } from 'react';
import { EERIE } from 'HubStyleTokens/colors';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import styled from 'styled-components';
import Small from 'UIComponents/elements/Small';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIExpandingTextArea from 'UIComponents/input/UIExpandingTextArea';
import { DEFAULT_ARTICLE_NAME, getArticleNamePlaceholder } from '../../../utils/articleUtils';
import MultilineCharacterCounter from './MultilineCharacterCounter';
import { jsx as _jsx } from "react/jsx-runtime";
const TitleEditorContainer = styled.div.withConfig({
  displayName: "TitleEditor__TitleEditorContainer",
  componentId: "sc-1w1qubz-0"
})(["width:688px;margin:80px auto 0;"]);
const TitleFieldTextArea = styled(UIExpandingTextArea).attrs({
  className: 'article-title-text'
}).withConfig({
  displayName: "TitleEditor__TitleFieldTextArea",
  componentId: "sc-1w1qubz-1"
})(["&&&&{padding:0;}&&::-webkit-input-placeholder{font-family:'Helvetica',sans-serif;font-size:2rem;font-weight:bold;}"]);
const TitleFieldFormControl = styled(UIFormControl).withConfig({
  displayName: "TitleEditor__TitleFieldFormControl",
  componentId: "sc-1w1qubz-2"
})(["&:not(.kb-character-counter) > label{opacity:", ";transition:opacity 0.2s;color:", ";font-weight:400;}"], props => props.showLabel ? 1 : 0, EERIE);
const I18nKey = key => `knowledgeContentUI.edit.fields.title.${key}`;
class TitleEditor extends Component {
  constructor(...args) {
    super(...args);
    this.preventDefaultEvent = e => {
      e.preventDefault();
    };
  }
  render() {
    const value = this.props.value === DEFAULT_ARTICLE_NAME ? '' : this.props.value;
    return /*#__PURE__*/_jsx(TitleEditorContainer, {
      onDragEnter: this.preventDefaultEvent,
      onDragOver: this.preventDefaultEvent,
      onDrop: this.preventDefaultEvent,
      children: /*#__PURE__*/_jsx(TitleFieldFormControl
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      , {
        showLabel: !value,
        label: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: I18nKey('label_jsx'),
          elements: {
            Small
          }
        }),
        required: true,
        children: /*#__PURE__*/_jsx(MultilineCharacterCounter, {
          "data-test-id": "article-title",
          disabled: this.props.disabled,
          inputRef: this.props.inputRef,
          maxLength: 200,
          maxLengthWarningThreshold: 10,
          onBlur: this.props.onBlur,
          onChange: this.props.onChange,
          placeholder: getArticleNamePlaceholder(),
          textAreaComponent: TitleFieldTextArea,
          value: value
        })
      })
    });
  }
}
export default TitleEditor;